import axios from 'axios';

const getUser = () => axios.get('/user');
const getRoles = (params) => axios.get('/roles', { params });

export default {
  getUser,
  getRoles,
};
